<template>
  <div class="pdf-print-cheers container">
    <b-overlay :show="loading" opacity="0.99">
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end"
      >
        <v-btn v-if="!loading" class="btn-print" v-on:click="printOut"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
      <table class="table table-sm bg-white">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <div>
                  <div v-if="resident.id" class="row">
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div
                      class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center"
                    >
                      <img
                        v-if="resident.photo_url"
                        class="resident_photo_url"
                        :src="resident.photo_url"
                      />
                      <img
                        v-if="!resident.photo_url"
                        class="resident_photo_url"
                        :src="require('../../../assets/user.png')"
                      />
                      <div class="ml-5">
                        <h6 class="mb-0">
                          {{ resident.name }}
                        </h6>
                        <h6 class="mb-0 worksansr upper-text">
                          Data de nascimento:
                          {{ formatDate(resident.date_of_birth, false) }}
                          -
                          {{ getAge(resident.date_of_birth) }}
                          anos
                        </h6>
                        <h6 class="mb-0 worksansr upper-text">
                          Data de admissão:
                          {{ formatDate(resident.date_of_reception, false) }}
                        </h6>
                        <h6
                          class="mb-0 worksansr upper-text"
                          v-if="resident.bed_id"
                        >
                          Leito Nº: {{ resident.bed_number }}, Andar:
                          {{ resident.bed_walk }}, ALA/Setor:
                          {{ resident.bed_ward_or_sector }}, Quarto:
                          {{ resident.bed_bedroom }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                    >
                      <img class="logo" :src="logo" width="180" />
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="content">
                <div
                  v-for="type in typesVitalSigns"
                  :key="type"
                  style="page-break-after: always !important"
                >
                  <hr class="mb-0" />
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th
                          class="text-center"
                          v-for="item in vital_signs"
                          :key="item.date"
                        >
                          {{ formatDate(item.date, false) }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- ABRE ALIMENTAÇÃO -->
                      <tr>
                        <td :colspan="vital_signs.length">
                          <div class="text-two text-type-cheers">
                            <strong>{{ type }}</strong>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="type == TYPE_ALIMENTACAO">
                        <td
                          v-for="(vital_sign, key) in vital_signs"
                          :key="key"
                          style="max-width: 90px"
                        >
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_has_feeding_care.length == 0"
                          >
                            --
                          </div>
                          <Alimentacao :vital_sign="vital_sign" />
                        </td>
                      </tr>
                      <!-- FECHA ALIMENTAÇÃO -->
                      <!-- ABRE DIURESE -->
                      <tr v-if="type == TYPE_DIURESE">
                        <td
                          v-for="(vital_sign, key) in vital_signs"
                          :key="key"
                          style="max-width: 90px"
                        >
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <Diurese
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA DIURESE -->
                      <!-- ABRE DOR -->
                      <tr v-if="type == TYPE_DOR">
                        <td
                          v-for="(vital_sign, key) in vital_signs"
                          :key="key"
                          style="max-width: 90px"
                        >
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <Dor
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA DOR -->
                      <!-- ABRE EVACUAÇÃO -->
                      <tr v-if="type == TYPE_EVACUACAO">
                        <td
                          v-for="(vital_sign, key) in vital_signs"
                          :key="key"
                          style="max-width: 90px"
                        >
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <Evacuacao
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA EVACUAÇÃO -->
                      <!-- ABRE FREQUÊNCIA RESPIRATÓRIA -->
                      <tr v-if="type == TYPE_FREQUENCIA_RESPIRATORIA">
                        <td
                          v-for="(vital_sign, key) in vital_signs"
                          :key="key"
                          style="max-width: 90px"
                        >
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <FrequenciaRespiratoria
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA FREQUÊNCIA RESPIRATÓRIA -->
                      <!-- ABRE GLICEMIA CAPILAR -->
                      <tr v-if="type == TYPE_GLICEMIA_CAPILAR">
                        <td
                          v-for="(vital_sign, key) in vital_signs"
                          :key="key"
                          style="max-width: 90px"
                        >
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <GlicemiaCapilar
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA GLICEMIA CAPILAR -->
                      <!-- ABRE PRESSÃO ARTERIAL -->
                      <tr v-if="type == TYPE_PRESSAO_ARTERIAL">
                        <td
                          v-for="(vital_sign, key) in vital_signs"
                          :key="key"
                          style="max-width: 90px"
                        >
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <PressaoArterial
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA PRESSÃO ARTERIAL -->
                      <!-- ABRE PULSO -->
                      <tr v-if="type == TYPE_PULSO_FREQUENCIA_CARDIACA">
                        <td v-for="(vital_sign, key) in vital_signs" :key="key">
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <Pulso
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA PULSO -->
                      <!-- ABRE SATURAÇÃO -->
                      <tr v-if="type == TYPE_SATURACAO_DE_OXIGENIO">
                        <td v-for="(vital_sign, key) in vital_signs" :key="key">
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <Saturacao
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA SATURAÇÃO -->
                      <!-- ABRE TEMPERATURA -->
                      <tr v-if="type == TYPE_TEMPERATURA_CORPORAL">
                        <td v-for="(vital_sign, key) in vital_signs" :key="key">
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <Temperatura
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA TEMPERATURA -->
                      <!-- ABRE PESO -->
                      <tr v-if="type == TYPE_PESO">
                        <td v-for="(vital_sign, key) in vital_signs" :key="key">
                          <div
                            class="text-center text-thirteen"
                            v-if="vital_sign.care_vital_signs.length == 0"
                          >
                            --
                          </div>
                          <div
                            style="page-break-inside: avoid !important"
                            class="text-center"
                            v-for="(
                              care_vital_sign, index
                            ) in vital_sign.care_vital_signs"
                            :key="index"
                          >
                            <div
                              v-for="item in care_vital_sign.care_has_vital_signs"
                              :key="item.id"
                              v-show="item.type == type"
                            >
                              <Peso
                                :item="item"
                                :care_vital_sign="care_vital_sign"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <!-- FECHA PESO -->
                    </tbody>
                  </table>
                </div>
                <div class="text-center">
                  Gerado por
                  {{
                    professionalClassCouncilValue({
                      id: user.professional_class_council_id,
                      name: user.name,
                      profile: user.profile_name,
                      cpf: user.cpf,
                      office: user.office,
                      value: user.professional_class_council_value,
                    })
                  }}
                  <small>
                    - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                  </small>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-end">
        <v-btn v-if="!loading" class="btn-print" v-on:click="printOut"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
import Alimentacao from "./Print/Types/Alimentacao";
import Diurese from "./Print/Types/Diurese";
import Dor from "./Print/Types/Dor";
import Evacuacao from "./Print/Types/Evacuacao";
import FrequenciaRespiratoria from "./Print/Types/FrequenciaRespiratoria";
import GlicemiaCapilar from "./Print/Types/GlicemiaCapilar";
import PressaoArterial from "./Print/Types/PressaoArterial";
import Pulso from "./Print/Types/Pulso";
import Saturacao from "./Print/Types/Saturacao";
import Temperatura from "./Print/Types/Temperatura";
import Peso from "./Print/Types/Peso";

import routes from "../../../routes";

import api from "../../../services/api";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import { getStatic } from "../../../lib/functions";

import { userData } from "../../../lib/functions";

import { getAge } from "../../../lib/getAgeByDate";

import moment from "moment";

export default {
  name: "Cheers",
  components: {
    Alimentacao,
    Diurese,
    Dor,
    Evacuacao,
    FrequenciaRespiratoria,
    GlicemiaCapilar,
    PressaoArterial,
    Pulso,
    Saturacao,
    Temperatura,
    Peso,
  },
  data() {
    return {
      user: {},
      resident: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      accessed_offline: false,
      resident_id: "",
      next_or_previous: "PREV",
      date: "",
      loading: false,
      vital_signs: [],
      errorsVitalSigns: [],
      typesVitalSigns: [
        "ALIMENTAÇÃO",
        "DIURESE",
        "DOR",
        "EVACUAÇÃO",
        "FREQUÊNCIA RESPIRATÓRIA",
        "GLICEMIA CAPILAR",
        "PRESSÃO ARTERIAL",
        "PULSO (FREQUÊNCIA CARDÍACA)",
        "SATURAÇÃO DE OXIGÊNIO",
        "TEMPERATURA CORPORAL",
        "PESO",
      ],
      TYPE_ALIMENTACAO: "ALIMENTAÇÃO",
      TYPE_DIURESE: "DIURESE",
      TYPE_DOR: "DOR",
      TYPE_EVACUACAO: "EVACUAÇÃO",
      TYPE_FREQUENCIA_RESPIRATORIA: "FREQUÊNCIA RESPIRATÓRIA",
      TYPE_GLICEMIA_CAPILAR: "GLICEMIA CAPILAR",
      TYPE_PRESSAO_ARTERIAL: "PRESSÃO ARTERIAL",
      TYPE_PULSO_FREQUENCIA_CARDIACA: "PULSO (FREQUÊNCIA CARDÍACA)",
      TYPE_SATURACAO_DE_OXIGENIO: "SATURAÇÃO DE OXIGÊNIO",
      TYPE_TEMPERATURA_CORPORAL: "TEMPERATURA CORPORAL",
      TYPE_PESO: "PESO",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    formatDate,
    professionalClassCouncilValue,
    async retrieve() {
      const { resident_id, date, next_or_previous } =
        routes.history.current.params;
      this.resident_id = resident_id;
      this.date = date;
      this.next_or_previous = next_or_previous;

      if (
        !resident_id ||
        !date ||
        !next_or_previous ||
        !["PREV", "NEXT"].includes(next_or_previous)
      ) {
        return;
      }

      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        let residents = (await getStatic("/offline/residents", true)).residents;

        let resident = residents.filter((item) => item.id == resident_id);

        if (resident[0]) {
          this.vital_signs = resident[0].cheers;
        }

        this.loading = false;
      } else {
        await this.getVitalSigns();
      }
    },
    async getVitalSigns() {
      try {
        this.loading = true;

        const { resident_id, next_or_previous, date } = this;

        let params = { resident_id, next_or_previous, date };

        const response = await api.get(
          "/rest-home/resident/cheers-vital-signs",
          {
            params,
          }
        );

        const { vital_signs, resident, error, errors } = response.data;

        if (error) {
          this.errorsVitalSigns = errors;
        } else {
          this.resident = resident;
          this.vital_signs = vital_signs;
          this.errorsVitalSigns = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    printOut() {
      window.print();
    },
  },
};
</script>


<style>
@media print and (-webkit-min-device-pixel-ratio: 0) {
  .pdf-print-cheers p {
    -webkit-print-color-adjust: exact !important;
  }
}

.pdf-print-cheers .header,
.pdf-print-cheers .header-space {
  height: 120px;
}
.pdf-print-cheers .header {
  position: fixed;
  top: 0;
}

.pdf-print-cheers .logo {
  height: 50px;
  object-fit: contain;
}

.pdf-print-cheers .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-print-cheers .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.pdf-print-cheers table,
.pdf-print-cheers tfoot {
  width: 100% !important;
  padding: 5px;
  cursor: auto !important;
}

.pdf-print-cheers th {
  background-color: #f5f5f5;
}

.pdf-print-cheers .text-type-cheers {
  display: flex;
  align-self: center;
  justify-content: center;
}

@media print {
  .pdf-print-cheers .header-space {
    background-color: #f5f5f5 !important;
    position: relative;
  }
  .pdf-print-cheers table {
    width: 100% !important;
    /* page-break-inside: always !important; */
    border: none !important;
    margin-top: 10px !important;
  }

  /* .pdf-print-cheers .content {
    page-break-inside: avoid !important;
  } */

  * {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-print-cheers button {
    display: none;
  }
}
</style>